module.exports = __webpack_public_path__ + "static/img/title-back.710faea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/casePage/title-back.png
// module id = odiO
// module chunks = 0